/* eslint-disable  */
import React from 'react';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import CssBaseline from '@material-ui/core/CssBaseline';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import EditIcon from '@material-ui/icons/Edit';
import { Tooltip } from '@material-ui/core';
import { useProperties } from '~/properties';
import { useAmenityTypes } from '../../api/amenity-types';
import { useAmenityTags } from '../../api/amenity-tags';
import Dimmer from '+/Dimmer';
import EnhancedTable from '../orders/components/EnhancedTable';
import { useReadAmenityNotes, useDeleteAmenityNotes, useFetchUnitTypeMappings } from '../../api/orders';
import { getState } from '../../store';
import { getUnitType, getSource, formatDate } from '../orders/utils/utils';

import orderBy from 'lodash/orderBy';
import {
    Dropdown
} from 'semantic-ui-react';


const ListOrders = () => {

    const { data: properties } = useProperties();

    const { data: amenity_tags, isFetchingAmenityTags } = useAmenityTags();
    const { data: amenity_types, isFetchingAmenityType } = useAmenityTypes();
    const [propertyId, setPropertyId] = React.useState(0);
    const { data: orders, isFetching } = useReadAmenityNotes(propertyId);
    const { data: unitTypeMappings, isFetchingUnitType } = useFetchUnitTypeMappings();
    const { mutate: deleteAmenityNotes } = useDeleteAmenityNotes();

    const { role } = getState().auth;

    const isNotUser = role !== 'user';


    const columns = [
        {
            Header: 'Unit',
            accessor: 'unit_space_name'
        },
        {
            Header: 'Unit Type',
            accessor: 'unit_type'
        },
        {
            Header: 'Source',
            accessor: 'source'
        },
        {
            Header: 'Name',
            accessor: 'amenity_name',
            minWidth: 250
        },
        {
            Header: 'Manager Notes',
            accessor: 'manager_notes'
        },
        {
            Header: 'Owner Notes',
            accessor: 'owner_notes'
        },
        {
            Header: 'Ordered',
            accessor: 'ordered'
        },
        {
            Header: 'Amount',
            accessor: 'total_current'
        },
        {
            Header: 'Paid',
            accessor: 'paid'
        },
        {
            Header: 'Date Paid',
            accessor: 'date_paid'
        },
        {
            Header: 'Date Ordered',
            accessor: 'date_ordered'
        },
        {
            Header: 'Check',
            accessor: 'check_number'
        }
    ];

    if (isFetching || isFetchingUnitType || isFetchingAmenityType || isFetchingAmenityTags) return <Dimmer />;

    // const orders_array = Object.values(orders);

    const inEntrataBase = orders.inEntrata;

    const notInEntrata = orders.notInEntrata || [];


    const allUnits = orders.allUnits;
    const unitTypeMappings2 = orders.unitTypeMappings;

    const arrayAll = orderBy(notInEntrata, ['unit_space_name']) || [];
    const lookup_code = arrayAll[0]?.lookup_code || 'pmaha';
    const ordersWithUnitType = arrayAll.map(element => {

        const { inEntrata, isCustom, isClean } = getSource(element, inEntrataBase, notInEntrata);

        const paid = value => {

            if (value === undefined) {
                return '';
            }

            if (value === true){
                return 'Yes';
            }

            return 'No';
        };

        let source = 'Custom';
        let icon = 'none';
        let color = 'black';

        if (inEntrata) {
            source = 'Entrata';

            if (!isClean) {
                icon = 'Clean';
            }
        }
        else {

            icon = 'Delete';

            if (!isCustom) {

                source = 'MissingEntrata';
                color = '#aaa';
            }
        }

        return ({
            unit_type: `${getUnitType(element, unitTypeMappings)}`,
            ...element,
            source,
            paid: paid(element.paid),
            date_paid: formatDate(element.date_paid),
            date_ordered: formatDate(element.date_ordered),
            ordered: formatDate(element.ordered)
        });
    })
    .filter((elem) => elem.source === 'MissingEntrata');


    const subjects = [];
    (properties || []).map(property => {


        const value = {
            key: property.id,
            text: property?.name,
            value: property.id
        };
        subjects.push(value);

        return subjects;
    });

    return (
        <div>
            <div>
                <Dropdown style={ {
                    padding: '18px',
                    color: '#002143',
                    minWidth: '849px',
                    fontSize: '13px'
                }}
                id='form-type'
                placeholder='Select Property'
                options={subjects}
                selection
                onChange={(e, { value }) => {
                    setPropertyId(value);
                }}
                value={propertyId || ''}
                />

            </div>


            {propertyId
                ? (<div style={{
                    marginTop: 20,
                    borderStyle: 'groove',
                    borderWidth: '1px'

                }}>
                    <CssBaseline />
                    <EnhancedTable
                        columns={columns}
                        data={ordersWithUnitType.flat()}

                    />
                </div>)
                : ''}




        </div>
    );
};

export default ListOrders;
